@file:OptIn(InternalResourceApi::class)

package helpmycity.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/helpmycity.shared.generated.resources/"

@delegate:ResourceContentHash(2_101_574_419)
internal val Res.drawable.helpy: DrawableResource by lazy {
      DrawableResource("drawable:helpy", setOf(
        ResourceItem(setOf(), "${MD}drawable/helpy.webp", -1, -1),
        ResourceItem(setOf(), "${MD}drawable/helpy.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_838_111_135)
internal val Res.drawable.ic_add: DrawableResource by lazy {
      DrawableResource("drawable:ic_add", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_add.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(341_576_042)
internal val Res.drawable.ic_back: DrawableResource by lazy {
      DrawableResource("drawable:ic_back", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_back.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_641_785_540)
internal val Res.drawable.ic_board: DrawableResource by lazy {
      DrawableResource("drawable:ic_board", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_board.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_004_640_397)
internal val Res.drawable.ic_close: DrawableResource by lazy {
      DrawableResource("drawable:ic_close", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_close.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_112_193_560)
internal val Res.drawable.ic_cloud_done: DrawableResource by lazy {
      DrawableResource("drawable:ic_cloud_done", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_cloud_done.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_055_575_868)
internal val Res.drawable.ic_cloud_off: DrawableResource by lazy {
      DrawableResource("drawable:ic_cloud_off", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_cloud_off.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-909_320_289)
internal val Res.drawable.ic_list: DrawableResource by lazy {
      DrawableResource("drawable:ic_list", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_list.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-92_091_868)
internal val Res.drawable.ic_map: DrawableResource by lazy {
      DrawableResource("drawable:ic_map", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_map.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(343_337_929)
internal val Res.drawable.ic_person: DrawableResource by lazy {
      DrawableResource("drawable:ic_person", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_person.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_769_677_304)
internal val Res.drawable.ic_review: DrawableResource by lazy {
      DrawableResource("drawable:ic_review", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_review.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_922_670_817)
internal val Res.drawable.ic_star: DrawableResource by lazy {
      DrawableResource("drawable:ic_star", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_star.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_596_649_546)
internal val Res.drawable.ic_sync_problem: DrawableResource by lazy {
      DrawableResource("drawable:ic_sync_problem", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_sync_problem.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("helpy", Res.drawable.helpy)
  map.put("ic_add", Res.drawable.ic_add)
  map.put("ic_back", Res.drawable.ic_back)
  map.put("ic_board", Res.drawable.ic_board)
  map.put("ic_close", Res.drawable.ic_close)
  map.put("ic_cloud_done", Res.drawable.ic_cloud_done)
  map.put("ic_cloud_off", Res.drawable.ic_cloud_off)
  map.put("ic_list", Res.drawable.ic_list)
  map.put("ic_map", Res.drawable.ic_map)
  map.put("ic_person", Res.drawable.ic_person)
  map.put("ic_review", Res.drawable.ic_review)
  map.put("ic_star", Res.drawable.ic_star)
  map.put("ic_sync_problem", Res.drawable.ic_sync_problem)
}
